import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CommonModule, NgFor, NgIf, NgOptimizedImage } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDrawer, MatSidenavModule } from "@angular/material/sidenav";
import { Subject, Subscription, takeUntil } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from "moment";
import { DynamicSettingsService } from "app/layout/common/dynamic-settings/dynamic-settings.service";
import { ModalComponent } from "app/modules/shared/modal.component";
import { ModalService } from "app/_services/modal.service";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserService } from "app/core/user/user.service";
import { fuseAnimations } from "@fuse/animations";
import { cloneDeep } from "lodash";
import { KeyPairsComponent } from "app/modules/shared/key-pairs/key-pairs.component";
import { GridsComponent } from "app/modules/shared/grids/grids.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MaterialModule } from "app/material.module";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { FuseAlertComponent } from "@fuse/components/alert";
import { CommonService } from "app/_services/common.service";
import { LoaderService } from "app/_services/loader.service";
import { BaseRequestService } from "app/_services/base.service";
import { MyToastrService } from "app/_services/toastr.service";
import { DomainDetailsComponent } from "../domain-details/domain-details.component";

const moment = _rollupMoment || _moment;

@Component({
  selector: "app-suspended-partners",
  standalone: true,
  imports: [
    CommonModule,
    GridsComponent,
    KeyPairsComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    ModalComponent,
    TableComponent,
    FuseScrollbarDirective,
    MaterialModule,
    AppFilterPipeModule,
    DynamicFormComponent,
    FuseAlertComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,
    DomainDetailsComponent
  ],
  templateUrl: "./suspended-partners.component.html",
  styleUrls: ["./suspended-partners.component.scss"],
})
export class SuspendedPartnersComponent {
  tenantUserDetailsData: any;
  @ViewChild("drawer") drawer: MatDrawer;
  drawerPosition: "start" | "end" = "end";
  drawerMode: "over" | "side" = "side";
  drawerOpened: boolean = false;
  cAsset: any;
  emailData: any;
  partnerstatsDataValue: any = []
  checkOpenDrawer: any;
  domainDetails: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  suspendedPartnersTableOptions: any = {};

  companyId: any;
  private subs: Subscription;
  private site: Subscription;
  addAsset: any = {};
  scanAsset: any = {};
  tenantUserDetails:any;
  importance: any = [
    { key: "Low", value: "25" },
    { key: "Medium", value: "50" },
    { key: "High", value: "75" },
    { key: "Critical", value: "100" },
  ];
  formElements: any = [
    {
      name: "name",
      description: "Name",
      example: "",
      min: 3,
      max: 25,
      required: true,
      schema: {
        type: "text",
      },
    },
    {
      name: "ip",
      description: "Asset IP",
      example: "",
      min: 3,
      max: 25,
      required: true,
      condition: "ip",
      schema: {
        type: "ip",
      },
    },
    {
      name: "importance",
      description: "Choose Importance",
      required: true,
      options: this.importance,
      schema: {
        type: "dropdown",
      },
    },
  ];
  scanTypeList = [
    { key: "Full Scan", value: 1 },
    { key: "Asset Scan", value: 2 },
    { key: "Active Directory Scan", value: 5 },
    { key: "SNMP Scan", value: 6 },
    { key: "LightWeight Agent Scan", value: 7 },
    { key: "Firewall Scan", value: 8 },
    { key: "PII Scan", value: 9 },
  ];
  addformElements = [];
  scanformElements: any;
  formScanElements: any = [
    {
      name: "scan_type",
      description: "Scan Type",
      example: "",
      required: true,
      searching: false,
      options: [
        { displayName: "Full Scan", value: "FULLSCAN" },
        { displayName: "Active Directory Scan", value: "ADSCAN" },
        { displayName: "Network Scan", value: "NETWORKSCAN" },
      ],
      schema: {
        type: "dropdown",
        key: "displayName",
        value: "value",
      },
    },
  ];
  suppressData: any = {};
  internalUsers: any = [];

  fromDate = new Date();
  fromMinEndDate: any = null;
  currentUser: any = "";
  reasonsList: string[] = [
    "Justified for business reasons",
    "False Positive",
    "Compensating control in place",
    "Other",
  ];
  UnsuspendPartnerData: any;
  cancelSubcriptionData: any;
  /**
   * Constructor
   */
  constructor(
    private cs: CommonService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private _ds: DynamicSettingsService,
    private _bs: BaseRequestService,
    public _modalService: ModalService,
    public _userService: UserService,
    private toast: MyToastrService,
    public confirmDialog: FuseConfirmationService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    this.subs = this._ds.suspendPartners.subscribe((res: any) => {
      if (res.target === 'check-email') {
        this._modalService.open("checkSuspenedEmailDetails");
      } else {
        this.assetActionCall(res);
      }
      // if (res.target === "unsuspend-partner") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.UnsuspendPartnerData = this.cs.selectedTableRows[0];
      //     this.openUnsuspendPartner()
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === "cancel-subscription") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.cancelSubcriptionData = this.cs.selectedTableRows[0];
      //     this.openCancelSubscription();
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === 'tenant-user-details') {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.tenantUserDetailsData = this.cs.selectedTableRows[0];
      //     this.checkOpenDrawer = "tenant-user-details";
      //     this.viewDistributor();
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === 'check-email') {
      //   this._modalService.open("checkEmail");
      // }
    });
    this.cs.afterAddPartner.pipe(takeUntil(this._unsubscribeAll))
    .subscribe((res: any) => {
      this.cs.checkDistributorID = res;
      let data = Object.assign({}, this.suspendedPartnersTableOptions);
      this.suspendedPartnersTableOptions = {}; 
      this._changeDetectorRef.detectChanges();
      data.pageData = []; data.tableOptions.pageTotal = 0;
      if (this.cs.currentScope !== '*') {
          data.tableOptions.serverSide.condition = `distributor_id=${parseInt(this.cs.currentScope.id)}`;
      } else {
          data.tableOptions.serverSide.condition = '';
      }
      this.suspendedPartnersTableOptions = data;
       this._changeDetectorRef.detectChanges();
      if (this.drawer.opened) {
        this.drawer.toggle().then((r) => console.log(r));
      }
    });
    this.site = this.cs.selectedSiteChanged.subscribe((cmp: any) => {
      this.cs.checkDistributorID = cmp;
      let data = Object.assign({}, this.suspendedPartnersTableOptions);
      this.suspendedPartnersTableOptions = {}; 
      this._changeDetectorRef.detectChanges();
      data.pageData = []; data.tableOptions.pageTotal = 0;
      if (this.cs.currentScope !== '*') {
          data.tableOptions.serverSide.condition = `distributor_id=${parseInt(this.cs.currentScope.id)}`;
      } else {
          data.tableOptions.serverSide.condition = '';
      }
      this.suspendedPartnersTableOptions = data;
       this._changeDetectorRef.detectChanges();
      if (this.drawer.opened) {
        this.drawer.toggle().then((r) => console.log(r));
      }
    });
    try {
      this.route.data.subscribe((v: any) => {
        this.suspendedPartnersTableOptions = {
          columns: [
            {
              header: "Distributor",
              columnDef: "distributor_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.distributor_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Tenant Name",
              columnDef: "tenant_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.tenant_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Status",
              columnDef: "subscription_status",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.subscription_status}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Assets Count",
              columnDef: "asset_size",
              cType: "number",
              filter: "",
              cell: "(element: any) => `${element.asset_size}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Version",
              columnDef: "version",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.version}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "First Name",
              columnDef: "first_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.first_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Last Name",
              columnDef: "last_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.last_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Cloud Region",
              columnDef: "region",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.region}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Email",
              columnDef: "email",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.email}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Domain",
              columnDef: "domain",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.domain}`",
              order: 0,
              isHyperlink: true,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            // {
            //   header: "Sub Distributor",
            //   columnDef: "sub_distributor",
            //   cType: "string",
            //   filter: "",
            //   cell: "(element: any) => `${element.sub_distributor}`",
            //   order: 0,
            //   visible: true,
            //   isToolTip: false,
            //   isToolTipCol: "",
            //   hasMultiData: false,
            //   class: "",
            //   color: "",
            //   isProgressCntrl: false,
            //   isColoredCntrl: false,
            //   colList: [],
            //   isfaicon: false,
            //   isAddingText: false,
            //   addingText: "",
            //   img: false,
            //   imgPath: "",
            //   isSort: true,
            //   iscolumnSearch: false,
            // },
            {
              header: "Paid End Date",
              columnDef: "paid_end_date",
              cType: "string",
              filter: "utcToLocale",
              width:'140px',
              cell: "(element: any) => `${element.paid_end_date}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Hosted By",
              columnDef: "hosted_by",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.hosted_by}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "POD ID",
              columnDef: "pod_id",
              cType: "number",
              filter: "checkingnull",
              cell: "(element: any) => `${element.pod_id}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Created",
              columnDef: "created",
              cType: "",
              filter: "utcToLocale",
              cell: "(element: any) => `${element.created}`",
              order: 0,
              width: "140px",
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Last Login Time",
              columnDef: "last_login_time",
              cType: "",
              filter: "utcToLocale",
              cell: "(element: any) => `${element.last_login_time}`",
              order: 0,
              width: "140px",
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Trial Ends On",
              columnDef: "trial_end_date",
              cType: "",
              filter: "utcToLocale",
              cell: "(element: any) => `${element.trial_end_date}`",
              order: 0,
              width: "140px",
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
          ],
          sortOptions: { active: "tenant_name", direction: "asc" },
          _pageData: [],
          tableOptions: {
            title: "Suspended Partners",
            isServerSide: false,
            selectText: "suspendedpartners(s)",
            loading: true,
            floatingFilter: true,
            rowSelection: false,
            showAction: true,
            actionMenuItems: [
              {
                name: "Tenant User Details",
                text: "Tenant User Details",
                id: "tenant-user-details",
                icon: "heroicons_mini:user-group",
                target: "tenant-user-details",
                emtterAction: "suspendPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
              {
                name: "Unsuspend Partner",
                text: "Unsuspend Partner",
                id: "unsuspend-partner",
                icon: "mat_outline:credit_score",
                target: "unsuspend-partner",
                emtterAction: "suspendPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
              // {
              //   name: "Cancel Subscription",
              //   text: "Cancel Subscription",
              //   id: "cancel-subscription",
              //   icon: "mat_outline:cancel_presentation",
              //   target: "cancel-subscription",
              //   emtterAction: "suspendPartners",
              //   isGlobal: false,
              //   callback: 'editFunction',
              // },
            ],
            pagination: true,
            pageOptions: [5, 10, 25, 100],
            pageSize: 10,
            search: false,
            saveData: true,
            showhideList: true,
            refreshData: true,
            showFilter: true,
            showTagFilter: false,
            exportExcel: true,
            add: false,
            columnSearch: false,
            compareData: false,
            filterDownload: false,
            isNotSiteChange: true,
            serverSide: {
              url: "/r/report_queries/partner_status",
              condition: ``,
              type: "post",
              isGlobal: true,
              params: { subscription_status: 'Suspended' },
            },
          },
          changeValue: new Subject<any>(),
        };
      });
    } catch (error) {
      console.error("Error retrieving route data:", error);
    }
  }

  ngOnInit(): void {
    if (this.cs.currentScope !== "*" ) {
      this.suspendedPartnersTableOptions.tableOptions.serverSide.condition = `distributor_id=${this.cs.currentScope.id}`;
    } else if (this.cs.currentScope === "*") {
      this.suspendedPartnersTableOptions.tableOptions.serverSide.condition = `true`
    } else {
      this.suspendedPartnersTableOptions.tableOptions.serverSide.condition = `true`
    }
    this._userService.userd$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: any) => {
        this.currentUser = user["email"];
      });
    this.scanformElements = this.cs.processFormElements(this.formScanElements);
  }
  viewDistributor() {
    this.drawerOpened = true;
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  deprecateRestoreAsset(idata: any, is_deprecated: any) {
    this.cs.reason = "";
    const onLine = idata.map((x: any) => x.updated_status === "Online");
    const titleName = !is_deprecated ? "Restore" : "Deprecate";
    const message =
      onLine && onLine.length
        ? `Are you sure that you need to ${titleName} an Online Agent(s)?`
        : `Do you want to ${titleName} the selected Asset(s)?`;
    const cancelText = "No";
    const acceptText = "Yes";
    const confirmation = this.confirmDialog.open({
      title: titleName,
      message: message,
      icon: { show: false, name: "", color: "accent" },
      actions: {
        confirm: { show: true, label: acceptText, color: "primary" },
        cancel: { show: true, label: cancelText },
      },
      dismissible: false,
      isReason: true,
    });
    confirmation.afterClosed().subscribe((result) => {
      if (result === "confirmed") {
        const params: any = {
          asset_ids: idata.map((x: any) => x.id),
          is_deprecated: is_deprecated,
          reason: this.cs.reason,
        };
        this.loaderService.display(true);
        this._bs
          .doRequest("/w/company/bulk_deprecate", "post", params)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((result: any) => {
            this.loaderService.display(false);
            if (result.status) {
              this.toast.sToast(
                "success",
                !is_deprecated
                  ? "Asset Restored Successfully."
                  : "Asset Deprecated Successfully."
              );
              setTimeout(
                () => this.suspendedPartnersTableOptions.changeValue.next(true),
                1000
              );
            } else {
              this.toast.sToast("error", result.message);
            }
          });
      }
    });
  }
  closeMethod() {
    this.tenantUserDetailsData = null;
    this.drawerOpened = false
  }

  cancelSuppress(): void {
    this._modalService.close("assetSupScanModal");
  }


  changeEvent(event: any) {
    this.fromMinEndDate = this.cs.getLastDay(1, event.value);
  }

  assetActionCall(res: any): void {
    const tableName: any = this.suspendedPartnersTableOptions.tableOptions.title;
    if (res.target === "unsuspend-partner") {
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.UnsuspendPartnerData = this.cs.selectedTableRows[tableName][0];
        this.openUnsuspendPartner()
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === "cancel-subscription") {
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.cancelSubcriptionData = this.cs.selectedTableRows[tableName][0];
        this.openCancelSubscription();
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === 'tenant-user-details') {
      this.tenantUserDetailsData=null;
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.tenantUserDetailsData = this.cs.selectedTableRows[tableName][0];
        this.checkOpenDrawer = "tenant-user-details";
        this.viewDistributor();
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === 'check-email') {
      this._modalService.open("checkSuspenedEmailDetails");
    }
  }
  actionCall(data: any) {
    const tableName: any = this.suspendedPartnersTableOptions.tableOptions.title;
    this.cs.selectedTableRows[tableName] = [data.row];
    this.assetActionCall(data.action);
  }

  linkClick(event: any) {
    if (event.col === "domain") {
      let skip = 0;
      let condition: any =
        this.cs.currentScope === '*'
          ? { condition: true, skip, limit: 100, tenant_id: event.row.tenant_id }
          : { condition: `distributor_id=${this.cs.currentScope.id}`, skip, limit: 100, tenant_id: event.row.tenant_id };

      this._bs
        .doRequest("/r/report_queries/partner_stats", "get", null, condition)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((result: any) => {
          if (result.status) {
            this.domainDetails = result.data;
            if (this.domainDetails.length > 0) {
              this.viewDomainDetails();
            } else {
              this.toast.sToast("error", 'No Data Found');
            }
          }
        });
    }
  }
  viewDomainDetails() {
    this.drawerOpened = true;
    this.checkOpenDrawer = "domain-details";
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  tabFnDetails($event: any): void {
    if ($event === 1) {
      // this.changePertnerStats(true)
    }
  }
  changePertnerStats(value?: any): void {
    let datavalue;
    let skip = 0;
    let condition: any;
    condition =
      this.cs.currentScope === '*'
        ? { condition: (datavalue) ? datavalue : true, skip, limit: 100, tenant_id: this.domainDetails[0].tenant_id }
        : { condition: (datavalue) ? `${datavalue} and distributor_id=${this.cs.currentScope.id}` : `distributor_id=${this.cs.currentScope.id}`, skip, limit: 100, tenant_id: this.domainDetails[0].tenant_id };
    this._bs
      .doRequest("/r/report_queries/partner_stats_view", "get", null, condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.partnerstatsDataValue = result.data;
        } else {
          this.toast.sToast("error", 'No data Found');
          this.partnerstatsDataValue = [];
        }
      });

  }
  viewAsset(asset: any): void {
    this.loaderService.display(true);
    this.cAsset = asset;
    this.drawerOpened = true;
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }

  filterTags($event: any): void {
    // console.log($event);
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.subs.unsubscribe();
    this.site.unsubscribe();
  }

  tabFn($event: any): void {
    switch ($event) {
      case 0:
        const data = Object.assign({}, this.suspendedPartnersTableOptions);
        this.suspendedPartnersTableOptions = {};
        this.suspendedPartnersTableOptions.pageData = [];
        this.suspendedPartnersTableOptions.tableOptions.pageTotal = 0;
        data.pageData = [];
        data.tableOptions.pageTotal = 0;
        this.suspendedPartnersTableOptions = data;
        break;
      default:
        break;
    }
  }

  toggleChange($event: any): void {
    this.cs.selctedAsset = "";
    this.drawer.toggle();
  }


  openUnsuspendPartner() {
    this._modalService.open("unsuspendPartner");
  }
  openCancelSubscription() {
    this._modalService.open("cancelSubscription");
  }
  cancelSubscriptionPartner(cancelSubcriptionData) {
    const request: any = {};
    request.tenantid = cancelSubcriptionData.tenant_id;
    request.reason = cancelSubcriptionData.reason;
    request.action = "Cancel Subscription";
    if (this.cs.currentScope !== "*") {
      request.distributor_id = this.cs.currentScope.id;
    }
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/partners/cancelpartner`, "patch", request)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Subscription Canceled successfully!");
          // this.drawerOpened = false;
          this._modalService.close("cancelSubscription");
          setTimeout(() => this.suspendedPartnersTableOptions.changeValue.next(true));
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  saveUnsuspendPartner(UnsuspendPartnerData) {
    const request: any = {};
    request.tenantid = UnsuspendPartnerData.tenant_id;
    request.reason = UnsuspendPartnerData.reason;
    request.id =UnsuspendPartnerData.id;
    request.action = "Partner unsuspend";
    request.subscription_status="Trial";
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/partners/unsuspend`, "post", request)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Unsuspend Partner successfully!");
          // this.drawerOpened = false;
          this._modalService.close("unsuspendPartner");
          setTimeout(() => this.suspendedPartnersTableOptions.changeValue.next(true));
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  deleteAsset($event: any): void {
    const confirmation = this.confirmDialog.open({
      title: "Confirmation",
      message: `Are you sure you want to delete these selected number (${this.cs.selectedTableRows.length}) of Asset(s)?`,
      actions: {
        confirm: {
          label: "Yes",
        },
      },
    });
    confirmation.afterClosed().subscribe((result) => {
      if (result === "confirmed") {
        const reqData: any = {
          ids: this.cs.selectedTableRows.map((obj: any) => obj.id),
        };
        this._bs
          .doRequest(`d/asset/assets/bulk_delete`, "post", reqData)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((result: any) => {
            if (result.status) {
              this.toast.sToast("success", "Removed successfully");
              setTimeout(() =>
                this.suspendedPartnersTableOptions.changeValue.next(true)
              );
            } else {
              this.toast.sToast("error", result.message);
            }
          });
      }
    });
  }
  checkEmailDeatilsValue(){
    this._modalService.open("tenantUserDetails");
  }
  checkEmail(data: any) {
    let condition = {
      tenantid: "",
      user_email: data
    }

    this._bs.doRequest(`/w/partners/user_exists`, 'post', condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.toast.sToast('success', result.message);
          this.tenantUserDetails = result;
          this.tenantUserDetails.message = this.tenantUserDetails.message.replace(/"/g, '');
          setTimeout(() => {
            this.suspendedPartnersTableOptions.changeValue.next(true);
          }, 3000);
          this.emailData = null;
          this._modalService.close("checkSuspenedEmailDetails");
          this.checkEmailDeatilsValue()
          setTimeout(() => {
            this.checkEmailDeatilsValue()
          }, 3000);
        } else {
          const data = (result.message) ? result.message : result.data;
          this.toast.sToast('error', data);
        }
      });
  }

  cancel():void{
    this.UnsuspendPartnerData.reason = '';
  }

}
